import { z } from "zod";

const TimeSlotSchema = z.object({
  open: z.string(),
  close: z.string(),
});

// Simple regex for ISO 8601 minute/hour durations (e.g., PT30M, PT1H, PT1H30M)
const isoDurationRegex = /^PT(?:(\d+)H)?(?:(\d+)M)?$/;

const CustomPrepTimeSlotSchema = TimeSlotSchema.extend({
  pickup: z.string().regex(isoDurationRegex).optional().nullable(),
  delivery: z.string().regex(isoDurationRegex).optional().nullable(),
});

export const AgentHoursSchema = z.object({
  monday: z.array(TimeSlotSchema),
  tuesday: z.array(TimeSlotSchema),
  wednesday: z.array(TimeSlotSchema),
  thursday: z.array(TimeSlotSchema),
  friday: z.array(TimeSlotSchema),
  saturday: z.array(TimeSlotSchema),
  sunday: z.array(TimeSlotSchema),
});

export const CustomPrepTimeHoursSchema = z.object({
  monday: z.array(CustomPrepTimeSlotSchema),
  tuesday: z.array(CustomPrepTimeSlotSchema),
  wednesday: z.array(CustomPrepTimeSlotSchema),
  thursday: z.array(CustomPrepTimeSlotSchema),
  friday: z.array(CustomPrepTimeSlotSchema),
  saturday: z.array(CustomPrepTimeSlotSchema),
  sunday: z.array(CustomPrepTimeSlotSchema),
});
